import { ArrowUpRight, Mail } from 'lucide-react'
import type { SiteCopy } from '../../content'

type FooterBlockProps = { copy: SiteCopy['footer'] }

export function FooterBlock({ copy }: FooterBlockProps) {
  return <footer className="site-footer"><div className="container footer-inner"><div className="footer-brand">© KÍMA / {copy.note}</div><div className="footer-links"><a href="#contact">{copy.contact}<ArrowUpRight aria-hidden="true" /></a><a href="/privacy">{copy.privacy}</a></div><span className="footer-note"><Mail aria-hidden="true" /> {copy.note}</span></div></footer>
}
